module.exports = __webpack_public_path__ + "static/media/mapMarkerOpen.ed40fb8b.svg";